import React from 'react';
import { node, string } from 'prop-types';

const LabelWrapper = ({ label, children, dataCy }) => (
  <div>
    <label data-cy={dataCy}>
      {label}
      {children}
    </label>
  </div>
);

LabelWrapper.propTypes = {
  label: string.isRequired,
  children: node.isRequired,
  dataCy: string
};

LabelWrapper.defaultProps = {
  dataCy: null
};

export default LabelWrapper;
